import { createSelector } from "@reduxjs/toolkit";

const getListPartnerApproval = (state) => state.listPartnerApproval;

const getIsGetPartnerApproval = (state) => state.isGetPartnerApproval;

const getIsRemovePartner = (state) => state.isRemovePartner;

const getIsAcceptPartner = (state) => state.isAcceptPartner;

const getIsRejectPartner = (state) => state.isRejectPartner;

const getTotal = (state) => state.total;

export const partnerApprovalSelector = createSelector(
  [
    getListPartnerApproval,
    getIsGetPartnerApproval,
    getIsRemovePartner,
    getIsAcceptPartner,
    getIsRejectPartner,
    getTotal,
  ],
  (
    listPartnerApproval,
    isGetPartnerApproval,
    isRemovePartner,
    isAcceptPartner,
    isRejectPartner,
    total
  ) => ({
    listPartnerApproval,
    isGetPartnerApproval,
    isRemovePartner,
    isAcceptPartner,
    isRejectPartner,
    total,
  })
);
